import { createContext, useContext } from 'react';
import type { useSupplierTerms } from './useSupplierTerms';

export const SupplierTermsContext = createContext<{
  terms: ReturnType<typeof useSupplierTerms>;
  openWelcome: () => void;
} | null>(null);

/** Retrieves the supplier agreement state and welcome dialog action. */
export function useSupplierTermsAccess() {
  const context = useContext(SupplierTermsContext);
  if (!context) throw new Error('SupplierTermsProvider is required');
  return context;
}
